import { createContext, useContext } from 'react';

export const ContactInfoListItemContext = createContext();

export const useContactInfoListItemContext = () =>
  useContext(ContactInfoListItemContext);

export default ContactInfoListItemContext;
